export default "https://cdn-static-staging.gokick.com/assets/8be3c2df1b703b0455f7e6e91c436c85253a82ea/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";